<template>
  <v-row class="login_container scroll-y align-center justify-center">
    <v-col
      class="align-center justify-center pa-0 "
      :class="{ 'fill-height': !$vuetify.breakpoint.mdAndUp }"
      cols="12"
      md="4"
    >
      <v-card
        class="login_form fill-height"
        :rounded="$vuetify.breakpoint.mdAndUp ? 'xl' : false"
      >
        <div class="alert_box">
          <v-alert class="ma-0" color="red" text v-show="errorMessage !== ''">
            {{ errorMessage }}
          </v-alert>
        </div>
        <v-card-title class="title_box">
          <v-col cols="10" offset="1">
            <div
              class="display-1 font-weight-black primary--text text-uppercase"
            >
              {{ $t('auth.login') }}
            </div>
          </v-col>
        </v-card-title>
        <v-row>
          <v-col cols="10" offset="1">
            <v-card-text class="my-4">
              <v-text-field
                :label="$t('auth.staffNo')"
                outlined
                prepend-inner-icon="person"
                required
                v-model="model.staffNo"
              ></v-text-field>
              <v-text-field
                :label="$t('auth.password')"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                outlined
                prepend-inner-icon="lock"
                required
                v-model="model.password"
                @click:append="showPassword = !showPassword"
                hide-details
              ></v-text-field>
              <v-checkbox
                dense
                v-model="remeber.isRemeber"
                :label="$t('auth.remeber')"
                class="mt-0"
              ></v-checkbox>
            </v-card-text>
            <v-card-actions>
              <v-btn
                block
                color="primary"
                :loading="loading"
                :disabled="!canSignIn"
                large
                @click="signIn"
                >{{ $t('auth.signIn') }}</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { LOGIN } from '@/store/mutation-types'
import cookies from 'js-cookie'
export default {
  data: () => ({
    model: {
      staffNo: '',
      password: ''
    },
    errorMessage: '',
    loading: false,
    showPassword: false,
    branchId: undefined,
    remeber: {
      isRemeber: false,
      ac: undefined,
      pwd: undefined
    }
  }),
  computed: {
    canSignIn () {
      return this.model && this.model.staffNo && this.model.password
    },
    progress () {
      return this.$store.getters.progress
    },
    postModel () {
      return {
        staffNo: this.model.staffNo || '',
        password: this.model.password || '',
        timezone: new Date().getTimezoneOffset() * -1
      }
    }
  },
  // created () {
  //   if (['development', 'dev'].includes(process.env.NODE_ENV)) {
  //     this.model.staffNo = ''
  //     this.model.password = ''
  //   }
  // },
  mounted () {
    this.branchId = this.$route.query.branch
    const remeber = this.getRemeber()
    if (remeber) {
      this.model.staffNo = remeber.ac
      this.model.password = remeber.pwd
      this.remeber.isRemeber = remeber.isRemeber
    }
  },
  methods: {
    signIn () {
      if (this.branchId) {
        this.errorMessage = ''
        this.loading = true
        this.$http
          .post('/sign-in', this.postModel)
          .then(resp => {
            if (!resp.data.data) {
              return
            }
            this.$store.commit(LOGIN, { data: resp.data.data })
            const hasRemeber = this.getRemeber()
            if (this.remeber.isRemeber && !hasRemeber) {
              this.setRemeber()
            } else {
              this.removeRemeber()
            }
            this.$router.push({
              path: '/home',
              query: {
                branch: this.branchId
              }
            })
            // if (this.$route.query.redirect) {
            //   this.$router.push({ path: this.$route.query.redirect })
            // } else {
            //   this.$router.push({ path: '/home' })
            // }
          })
          .catch(e => {
            this.errorMessage = e
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.errorMessage = this.$t('auth.reScan')
        return false
      }
    },
    setRemeber () {
      this.remeber.ac = this.model.staffNo
      this.remeber.pwd = this.model.password
      cookies.set('remeber', JSON.stringify(this.remeber), { expires: 30 })
    },
    getRemeber () {
      let remeber = cookies.get('remeber') || undefined
      if (remeber) {
        remeber = JSON.parse(remeber)
      }
      return remeber
    },
    removeRemeber () {
      cookies.remove('remeber')
    }
  }
}
</script>

<style lang="scss">
.login_container {
  height: 100vh;
  background: #e9e9e9;

  .login_form {
    padding-bottom: 56px;
    width: 100%;
    overflow: hidden;
    .alert_box {
      height: 56px;
      margin-bottom: 4px;
    }
    .title_box {
      border-left: 6px solid #1976d2;
    }
  }
  .link {
    background-color: transparent;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
